import { render, staticRenderFns } from "./CadAlimentacao.vue?vue&type=template&id=8091d624&"
import script from "./CadAlimentacao.vue?vue&type=script&lang=js&"
export * from "./CadAlimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports